import React, {useState, useMemo, useEffect} from 'react';
import { useFetchData } from '../../../hooks/useFetchData/useFetchData';
import dayjs from 'dayjs';
import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Paper, Select, TextField, Typography } from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import { DatePicker, LocalizationProvider, ptBR } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import RequestsTableModalCharts from '../../../components/requests/requestsTable/requestsTableModalCharts';
import RequestAdmin from '../../../components/requests/requestsModais/requestAdmin/requestAdmin';
import LoadingFull  from '../../../components/shared/loadingFull';

//Types 
import { dataType } from '../types/types';
//Utils
import { months } from '../utils/dateUtils';

//styles
import { chartContainerBodyH, chartContainerBodyV } from '../styles/styles';
import { getHeightChart } from '../utils/stylesUtils';
import { ChartOptions } from '../components/ChartOptions';
import { getChartOptionsHorizontal, optionsVertical } from '../config/chartOptions';
import useFiltersStore from '../store/filtersStore';
import UserSelect from '../../../components/shared/UserSelect';
import Client from '../../../components/administrative/clients/client/client';
import { clientFn } from '../../../services/clients';
import { set } from 'react-hook-form';
import UserGroupSelect from '../../../components/shared/GroupUserSelect';
import { useCryptoSessionStorage } from '../../../hooks/useCryptoSessionStorage';
import ClientsNotRequests from '../../../components/administrative/clients/clientsNotRequests';
import { requestsByTypeFn } from '../../../services/requests';

const IsDev = process.env.REACT_APP_AMBIENTE_DEV === 'true';
let url = process.env.REACT_APP_API+ "/charts";
let urlUsers = process.env.REACT_APP_API+ "/user/all";

const RequestsChartsPage = () => {
    const { getData } = useCryptoSessionStorage();
    const user = useMemo(() => getData("user") || {}, []);    
    const [data, setData] = useState<dataType>({labels: [], datasets: []});
    const [totalRequests, setTotalRequests] = useState(0);
    const [filtersValues, setFiltersValues] = useState<any[]>([]); //Acessar os atendimentos clicando no gráfico
    const [animations, setAnimations] = useState(false);
    const [changed, setChanged] = useState(false);
    const [openConfig, setOpenConfig] = useState(false);
    const [labelsCount, setLabelCount] = useState(0);
    const [requestsClick, setRequestsClick] = useState({});
    const [titleRequests, setTitleRequests] = useState('');
    const [openRequest, setOpenRequest] = useState(false);
    const [values, setValues] = useState({});
    const [requestsClickOpen, setRequestsClickOpen] = useState(false);
    const [client, setClient] = useState({});
    const [openClient, setOpenClient] = useState(false);
    const filters = useFiltersStore(state => state);
    const [clientSelected, setClientSelected] = useState<any>(null);
    const [clientsList, setClientsList] = useState<any[]>([]);

    useEffect(() => {
    if (filters?.option === 12) {
        clientFn({ all: true }).then((res) => {
        if (res) setClientsList(res);
        });
    }
    }, [filters?.option]);

    const handleSearchClients = async (value: string) => {
    if (!value || value.length < 2) return; // só busca com 2+ caracteres
    try {
        const res = await fetch(`${process.env.REACT_APP_API}/client/search?search=${value}`);
        const data = await res.json();
        setClientsList(data);
    } catch (error) {
        console.error("Erro ao buscar clientes", error);
    }
    };

    const optionsReports = [
        { value: 1, label: '1 - Atendimentos Geral por tipo - Mês/Ano', permissionField: 'requests_charts_1' },
        { value: 2, label: '2 - Atendimentos Geral - Período', permissionField: 'requests_charts_2' },
        { value: 3, label: '3 - Atendimentos por Usuário - Dia a Dia', permissionField: 'requests_charts_3' },
        { value: 4, label: '4 - Total de Atendimentos - Período - Ord. Nome', permissionField: 'requests_charts_4' },
        { value: 5, label: '5 - Total de Atendimentos - Período - Ord. Quantidade', permissionField: 'requests_charts_5' },
        { value: 6, label: '6 - Clientes que mais solicitaram Atendimentos - Geral', permissionField: 'requests_charts_6' },
        { value: 7, label: '7 - Tipos de Atendimentos mais solicitados', permissionField: 'requests_charts_7' },
        { value: 8, label: '8 - Total de Atendimentos por Cliente x Valor de Manutenção', permissionField: 'requests_charts_8' },
        { value: 9, label: '9 - Total de Atendimentos por Sistema x Valor de Manutenção', permissionField: 'requests_charts_9' },
        // { value: 10, label: 'Clientes que não solicitaram atendimentos por sistema' },
        { value: 11, label: '10 - Clientes que Solicitaram x Não Solicitaram atendimentos', permissionField: 'requests_charts_10' },
        { value: 12, label: '11 - Clientes que não solicitaram atendimentos - Lista', permissionField: 'requests_charts_11'},
        { value: 13, label: '12 - Atendimentos por Cliente - Dia a Dia', permissionField: 'requests_charts_12'},
    ];

    const availableReports = useMemo(
            () => optionsReports.filter(opt => user[opt.permissionField] === 'Y'),
            [user]
            );

            useEffect(() => {
            if (!availableReports.length) return;
            if (!availableReports.some(r => r.value === filters.option)) {
                useFiltersStore.setState(s => ({
                ...s,
                option: availableReports[0].value
                }));
            }
            }, [availableReports, filters.option]);

    const segments = [
       'Todos',
       'Automação',
       'Ponto',
       'Assistência',
       'Gestão',
       'Interno',
    ];

    const {  getDataDirectly, loading, setLoading } = useFetchData();
    
    const handleChanged = () => {
        setChanged(!changed);
    }

    const handleCloseConfig = () => {
        setOpenConfig(false);
      }
    
      const handleOpenFilter = () => {
        setOpenConfig(true);
    }

    const handleChangeFilters = (value: any) => {
        useFiltersStore.setState((prevState) => ({
          ...prevState,
          [value.target.name]: value.target.value,
        }));
      
        const optionsY = [4, 5, 6, 7, 8, 9];
        if (value.target.name === 'option') {
            if(optionsY.includes(value.target.value)){
                handleChangeOrientation('y');
              } else {
                handleChangeOrientation('x');
            }
        } 
    };
      
    const handleChangeOrientation = (value: 'x' | 'y') => {
        useFiltersStore.setState((prevState) => ({
            ...prevState,
            orientation: value,
        }));
    };


    const handleChangeFiltersDate = (field: string, value: any) => {
        useFiltersStore.setState((prevState) => ({
            ...prevState,
            [field]: dayjs(value).format('YYYY-MM-DD'), 
        }));

        if(filters.option === 3 && field === 'InitialDate'){
            useFiltersStore.setState((prevState) => ({
                ...prevState,
                ['FinalDate']: dayjs(value).format('YYYY-MM-DD'), 
            }));          
        }
    };

    const handleChangeUser = (values: any) => {
        useFiltersStore.setState((prevState) => ({
            ...prevState,
            ['user']: (!values) ? null : values.id,
        })); 
        useFiltersStore.setState((prevState) => ({
            ...prevState,
            ['userName']: (!values) ? null : values.name,
        }));          
    };

    const handleChangeUserGroup = (values: any) => {
        useFiltersStore.setState((prevState) => ({
            ...prevState,
            ['userGroup']: (!values) ? null : values.id,
        })); 
        useFiltersStore.setState((prevState) => ({
            ...prevState,
            ['userGroupName']: (!values) ? null : values.description,
        }));          
    }

    const handleOpenRequests = () => {
        setRequestsClickOpen(true);
    };

    const handleOpenClient = async (id: number) => {
        const client = await clientFn({id});
        if(client){
            setClient(client);
            setOpenClient(true);
        }
    };

    const handleClickOption7 = async (id: number, label: string) => {
        try {
            setLoading(true);
            const requests = await requestsByTypeFn({id, startDate: filters.InitialDate, endDate: filters.FinalDate});
            if(requests){
                setRequestsClick(requests);
                setTitleRequests('Atendimentos - ' + label);
                handleOpenRequests();
            }
        } catch (error) {
            console.log('error', error);
        } finally {
            setLoading(false);
        }

    };

    const handleClickRequest = async (i: any) => {

        const validOptions = [3, 4, 5, 6, 7, 13];	

        const idOuDia: any = filtersValues[i[0].index];
        
        if(!validOptions.includes(filters?.option)){
            return;
        }

        const date: any = filtersValues[i[0].index];
        if(filters?.option === 6 ){
           return handleOpenClient(idOuDia);
        }

        if(filters?.option === 7 ){
            return handleClickOption7(date, data.labels[i[0].index]);
        }

        if (filters?.option === 13) {
            if (idOuDia) return handleOpenClient(idOuDia); // 🔹 igual ao 6
           return;
        }

        const user = data.datasets[i[0].datasetIndex].label;
        const userLabel = data.labels[i[0].index];
        const setRequests = () => {
            return new Promise((resolve, reject) => {
                let requests = {};
                switch (filters?.option) {
                    // case 3: {
                    //    requests = requestsList.filter((r) => {
                    //         return r?.nameUser === user && r?.conclusion_day === dayjs(date.day).format('DD/MM/YYYY');
                    //    });
                    //    break;
                    // };
                    // case 4: {
                    //     requests = requestsList.filter((r) => {
                    //          return  r?.nameUser === userLabel;
                    //     });
                    //     break;
                    //  };      
                    default:
                        break;
                }

                resolve(setRequestsClick(requests));
            })
        };

        await setRequests();
        setTitleRequests('Atendimentos - ' + user);
        handleOpenRequests();
    }

    const updateFilter = async() => {
        setData({
            labels: [],
            datasets: []
        });
        setTotalRequests(0);

        if(filters?.option === 12){
            handleCloseConfig();
            handleChanged();
            return;
        }

        if (filters?.option === 13 && !clientSelected?.id) {
        handleCloseConfig();
        return;
         }

        await getDataDirectly(url, {
            chart: true,
            year: filters?.year,
            month: filters?.month,
            user: (filters?.option === 4 || filters?.option === 5) ? 0 : filters?.user,
            option: filters?.option,
            FilterDate: filters?.option > 1,
            InitialDate: dayjs(filters?.InitialDate).utc(true).format('YYYY-MM-DD'),
            FinalDate: dayjs(filters?.FinalDate).utc(true).format('YYYY-MM-DD'),
            order: (filters?.option === 5 || filters?.option === 3 || filters?.option === 7) ? 'total' : 'name', 
            orderChart: filters?.option === 3 ?  filters?.orderChart : 'desc',
            userGroup: filters?.userGroup,
            limit: filters?.limit || 10,
            segment: filters?.segment,
            clientId: clientSelected?.id || null   
        },
        async (response: any) => {
            setData(response?.chartData);
            setTotalRequests(response?.totalRequests);
            const labelsLen = response?.chartData?.labels?.length || 0;
            const serverFilters = response?.filters ?? response?.filter; // case 2/13 usa 'filter' (singular)
            setFiltersValues(
            (filters?.option === 13 && clientSelected?.id)
                ? Array(labelsLen).fill(clientSelected.id)   // 🔹 igual ao 6: índice → id do cliente
                : serverFilters
            );
            setLabelCount(response?.chartData.labels.length);
            handleCloseConfig();
            handleChanged();
        }
        )
    }

    useEffect(() => {
        if (filters) {
            updateFilter();
        }
    }, [filters?.orderChart]);

    const getChartByTypeHorizontal = () => {
        return <ChartOptions typeChart={filters?.typeChart} optionChart={filters?.option} options={getChartOptionsHorizontal(filters?.option, filters?.orientation, animations, handleClickRequest)} data={data} />
    };

    const getChartByTypeVertical = () => {
        return <ChartOptions typeChart={filters?.typeChart} optionChart={filters?.option} options={optionsVertical(filters?.option, filters?.orientation, animations, handleClickRequest)} data={data} />
    };

    const LabelFilter  = useMemo(() => {
        if(filters?.option === 1 || filters?.option === 2 ){
            return (filters?.month) ? `${months[filters?.month -1].name}, ${filters?.year}` : 'Todos';
        } else {
            return `${dayjs(filters?.InitialDate).format('DD/MM/YYYY')} a ${dayjs(filters?.FinalDate).format('DD/MM/YYYY')}`
        }
    }, [changed]);  

    const ChartHorizontal = useMemo(() => {
        return getChartByTypeHorizontal();
    }, [changed, filters?.option]);  

    const ChartVertical  = useMemo(() => {
        return getChartByTypeVertical();
    }, [changed, filters?.option]);  


    if(window.innerWidth < 500){
        return (
            <Box sx={{width: '100%', textAlign: 'center', justifyContent: 'center', alignItems: 'center', mt: 20, userSelect: 'none',}}>
            <Box className="header-atendimento">
              <Typography variant="h4"  color="text.secondary" >
                Dispositivo incompatível.
              </Typography>
              <Typography color="text.secondary" gutterBottom>
                Acesse o Sirrus Atendimento do seu computador para visualizar os gráficos disponíveis.
              </Typography>
            </Box>
              <div >
                <img width={'100%'}  src="https://gifs.eco.br/wp-content/uploads/2022/10/gifs-de-graficos-0.gif" alt="Aguarde" />
              </div>
            </Box>
        )
    } else {
    return (    
         <div className=" flex flex-col p-3 "> 
            <div className="" > {/*sx={{ p: '2px 4px', display: 'flex', mb: 0.5  }}*/}
                <Grid container spacing={1} columns={ 12 } sx={{float: "center", width: '100%',}} >
                    <Grid item xs={12} sm={12} md={9} lg={5} xl={5} sx={{mt: 1, }} > 
                        <Paper elevation={3} sx={{width: '100%', p: 1, fontSize: 12}} >
                            <Typography>
                                Gráfico:{' '}
                                {availableReports.find(r => r.value === filters?.option)?.label || ' — '}
                            </Typography>
                            <Typography>Período: {LabelFilter}</Typography> 
                            <Typography>Usuário: {(filters?.user) ? filters?.userName : 'Todos'}</Typography> 
                            <section className="flex flex-row justify-between">
                                <Typography>Segmento: {(filters?.segment) ? filters?.segment : 'Todos'}</Typography>
                                <Typography>Total: {totalRequests}</Typography>
                            </section>                     
                        </Paper>
                    </Grid>  
                    <Grid item xs={12} sm={12} md={3} lg={2} xl={2} sx={{mt: 1, mb: 1}} >
                    <Button
                        variant='outlined'
                        onClick={handleOpenFilter}
                        endIcon={<SettingsIcon />}
                        sx={{ mr: 1,   p: '10px', fontSize: 12 }}   
                        size="small"     
                    >   
                        Opções 
                    </Button>
                    </Grid>                  
                </Grid>
            </div>
            {
                (filters?.option === 12) ? (
                    <ClientsNotRequests startDate={filters?.InitialDate} endDate={filters?.FinalDate} segment={filters?.segment} handleChanged={handleChanged} changed={changed} />
                ) 
                :
                (
                    <div className="flex justify-center overflow-x-hidden overflow-y-scroll flex-wrap h-full ml-2 " >
                        <div className="m-2">
                            <div className="overflow-x-hidden">
                                { (filters?.orientation === 'y') ? (
                                        <Box sx={chartContainerBodyV(filters, labelsCount)}>
                                        <Box sx={{height: getHeightChart(filters, labelsCount), overflowY: 'auto'}}>
                                            {ChartVertical}
                                        </Box>                             
                                        </Box>
                                    ) : 
                                    (
                                        <Box sx={chartContainerBodyH(filters, labelsCount)}>                    
                                            {ChartHorizontal}
                                        </Box>
                                    ) 
                                }
                            </div>
                        </div>
                    </div>  
                )

            }  
            <LoadingFull open={loading} /> 
            <Dialog open={openConfig} onClose={handleCloseConfig} > 
            <DialogTitle>Opções de Gráficos</DialogTitle>
            <DialogContent>                       
            <Grid container spacing={1} columns={ 12 } sx={{float: "center"}} >
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{mt: 1, mb: 1, }} >
                    <FormControl fullWidth>
                        <InputLabel id="chart-option">Qual informação deseja visualizar?</InputLabel>
                        <Select
                            labelId="chart-option"
                            label="Qual informação deseja visualizar?"
                            fullWidth
                            name='option'
                            value={filters?.option}
                            onChange={handleChangeFilters}
                            >
                            {availableReports.map(opt => (
                                <MenuItem key={opt.value} value={opt.value}>
                                {opt.label}
                                </MenuItem>
                            ))}
                            </Select>
                    </FormControl>  
                </Grid>              
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{display: (filters?.option === 1) ? 'none' : ''}}  >
                    <LocalizationProvider dateAdapter={AdapterDayjs} localeText={ptBR.components.MuiLocalizationProvider.defaultProps.localeText}>
                        <DemoContainer components={['DatePicker']} >
                        <DatePicker 
                            label="Data Inicial" 
                            value={dayjs(filters.InitialDate).utc(IsDev)}
                            onChange={(newValue) => handleChangeFiltersDate('InitialDate', newValue)}
                            format="DD/MM/YYYY" 
                            sx={{width: '100%'}}
                        />
                        <DatePicker 
                            label="Data Final" 
                            value={dayjs(filters.FinalDate).utc(IsDev)}
                            onChange={(newValue) => handleChangeFiltersDate('FinalDate', newValue)}
                            format="DD/MM/YYYY" 
                            sx={{width: '100%', display: (filters?.option === 3) ? 'none' : ''}}
                        />               
                        </DemoContainer>         
                    </LocalizationProvider>       
                </Grid>             
                <Grid item xs={12} sm={12} md={7} lg={7} xl={7} sx={{mt: 1, mb: 1, display: (filters?.option === 1) ? '' : 'none'}} >
                    <FormControl fullWidth>
                        <InputLabel id="type-chart-period">Mês</InputLabel>
                        <Select
                            labelId="type-chart-period"
                            label="Mês"
                            fullWidth 
                            name='month'
                            value={filters?.month} 
                            onChange={handleChangeFilters}
                        >
                            {months && months.map((month) => { return ( <MenuItem value={month.value}><em>{month.name}</em></MenuItem> )})}     
                        </Select>
                    </FormControl>  
                </Grid>  
                <Grid item xs={12} sm={12} md={5} lg={5} xl={5} sx={{mt: 1, mb: 1, display: (filters?.option === 1) ? '' : 'none'}} >
                    <TextField
                        fullWidth
                        label="Ano"
                        type="number"
                        name='year'
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={filters?.year}
                        onChange={handleChangeFilters}
                    /> 
                </Grid>   
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={1} sx={{display: [1, 2].includes(filters?.option) ? '' : 'none'}}>
                    <UserSelect  
                        label="Atendente"
                        value={filters?.user} 
                        setValue={handleChangeUser} 
                        name="user" 
                        formik={null}
                        error={false}
                        helpText={''}
                    />
                </Grid>                   
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={1} sx={{display: (filters?.option === 3) ? '' : 'none'}}>
                    <UserGroupSelect  
                        label="Setor"
                        value={filters?.userGroup} 
                        setValue={handleChangeUserGroup} 
                        name="user" 
                        formik={null}
                        error={false}
                        helpText={''}
                    />
                </Grid>   
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={1} sx={{ display: (filters?.option === 13) ? '' : 'none' }}>
                <Autocomplete
                    options={clientsList}
                    getOptionLabel={(option: any) => option.nome_fantasia || ""}
                    value={clientSelected}
                    onChange={(event, newValue) => setClientSelected(newValue)}
                    onInputChange={(event, newInputValue) => handleSearchClients(newInputValue)} 
                    renderInput={(params) => (
                        <TextField {...params} label="Selecione o Cliente" fullWidth />
                    )}
                    />
                </Grid>                
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={1} sx={{display: (filters?.option === 3) ? 'none' : ''}}>
                    <FormControl fullWidth>
                        <InputLabel id="type-chart">Tipo de Gráfico</InputLabel>
                        <Select
                            labelId="type-chart"
                            label="Seguimento"
                            fullWidth 
                            name='segment'
                            value={filters?.segment} 
                            onChange={handleChangeFilters}
                        >
                            {
                                segments && segments.map((segment) => { return ( <MenuItem value={segment}><em>{segment}</em></MenuItem> )})
                            }
                        </Select>
                    </FormControl>  
                </Grid>
                {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={1} >
                    <FormControl fullWidth>
                        <InputLabel id="type-chart">Tipo de Gráfico</InputLabel>
                        <Select
                            labelId="type-chart"
                            label="Tipo de Gráfico"
                            fullWidth 
                            name='typeChart'
                            value={filters?.typeChart} 
                            onChange={handleChangeFilters}
                        >
                            <MenuItem value={1}><em>Barras</em></MenuItem>
                            <MenuItem value={2}><em>Linhas</em></MenuItem>
                        </Select>
                    </FormControl>  
                </Grid> */}
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={1} sx={{display: ([6, 7, 8, 9].includes(filters?.option)) ? '' : 'none'}} >
                    <TextField
                        id="outlined-number"
                        label="Número de Registros"
                        fullWidth
                        name='limit'
                        value={filters?.limit} 
                        onChange={handleChangeFilters}
                        type="number"
                    />
                </Grid>
                {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12} marginBottom={1} > 
                <FormControlLabel  control={
                    <Checkbox
                        checked={animations}
                        onChange={(e) => setAnimations(e.target.checked)}
                        inputProps={{ 'aria-label': 'controlled' }}
                    /> 
                    } label="Gráfico Animado" 
                />
                </Grid> */}
            </Grid>
            </DialogContent>
            <DialogActions>
                <Button variant="outlined" color={'warning'} onClick={handleCloseConfig}>Fechar</Button>
                <Button variant="outlined" onClick={updateFilter}>Aplicar</Button>
            </DialogActions>        
            </Dialog>
            <RequestsTableModalCharts title={titleRequests} values={requestsClick} setOpen={setRequestsClickOpen} setOpenRequest={setOpenRequest} changed={changed} setValues={setValues} open={requestsClickOpen} handleChanged={updateFilter}/>
            <RequestAdmin values={values} open={openRequest} setValues={setValues} setOpenRequest={setOpenRequest} changed={changed} setChanged={setChanged} handleChanged={handleChanged}  />
            <Client values={client} open={openClient} setOpen={setOpenClient} /> 
        </div>
    )};
}

export default RequestsChartsPage;